<template>
    
        <v-card  class="pb-80 events" elevation=0 >
            <v-card-title class="pa-0">
                 
                <v-img  :src="(business.thingsimage=='null' || business.thingsimage==null )?bannerImg:business.thingsimage " aspect-ratio="1" class="lighten-2 " max-height="287">
                    <v-row class="fill-height align-center" style="background:rgba(0,0,0, 0.4);">
                        <v-col cols="12" md="12" sm="12" class=" white--text pl-30">
                            <!-- <h2 class="heading" v-if="business.thingsimagetitle==''">Things To Do...</h2> -->
                            <h2 class="heading" >{{business.thingsimagetitle}}</h2>
                            <span class="body-1" v-if="business.thingsimagedescription!=''">{{business.thingsimagedescription}}</span>

                                    
                        </v-col>
                                
                    </v-row>
                            
                </v-img>
                        
                   
            </v-card-title>

            <v-card-text class="mb-auto pwa-content pa-0 ">
                <v-tabs background-color="transparent" color="#FE5800"  grow show-arrows>
                    <v-tab v-for="(item, index) in business.events" :key="index"  class="white--text" >
                            {{ index }}
                            
                    </v-tab>
                    <v-tab-item v-for="(item, index) in business.events" :key="index" class="pl-3 pr-3 pte-15">
                    
                    <a v-for="(ev,ind) in item" :key="ind" @click="eventdetails(ev.id)">  
                        <v-card >
                            <v-card-text class="pt-0 pb-0 pl-2 pr-2 mb-35" >
                                       <v-row>
                                        <v-col cols="4" md="4" sm="4" class="pt-2 pb-2">
                                            <v-img :src="ev.image" max-height="100"></v-img>
                                        </v-col>
                                        <v-col cols="8" md="8" sm="8" class="pt-2 pb-2" >
                                        <div class="eventdate" v-if="ev.sdate!=''">{{ev.sdate}}</div>
                                        <div class="body-2">{{ev.category}}</div>
                                        <div class="subtitle-1 font-weight-bold"> {{ev.title}} </div>
                                        <div class="body-2">{{ev.subtitle}}</div>
                                        <div class="body-2">{{ev.frequency}}</div>
                                        </v-col>
                                    </v-row>
                                
                            </v-card-text>
                        </v-card>

                        </a>

                    </v-tab-item>
                </v-tabs>
            </v-card-text>

            

        </v-card>
        
    
</template>
<script>
import Vue from 'vue'
import { EventBus } from '@/event-bus';

export default {
    props:['business'],
    data: () => 
    ({
        bannerImg:require('@/assets/overview-banner.jpg'),
       // bannerImg:'',
        //logoImg:require('@/assets/logo.svg'),
        
        
    }),
    
    methods:
    {
        
        eventdetails(eventid)
        {
           // this.$router.push({name:'eventdetails',params:{id: eventid,businessid:this.business_id}});
          // this.$emit('eventclick',eventid);
           EventBus.$emit('eventclick', eventid);
        },
       
    
   },
}
</script>
<style scope>
.v-tab{
    min-width:50px;
    padding: 0px 10px;
} 
.eventdate{
    position: absolute;
    padding:0.75rem 0.5rem ;
    right: 0.5rem;
    background: #FE5800;
    color: #fff;
    font-weight: bold;
    font-size: 18px;
    top:-1.2rem;
}
.mb-35
{
    margin-bottom: 35px;
}
.pte-15{
    padding-top:3rem !important;
}
.pwa-content{
    margin-top: -60px;
}
.f-btn .v-btn__content
{
    -webkit-box-orient: vertical;

-webkit-box-direction: reverse;

-ms-flex-direction: column-reverse;

flex-direction: column-reverse;
}
.mt-60-n{
    margin-top:-60px;
}
.pb-80{
    padding-bottom: 80px;
}
.v-card__title{
    word-break: normal;
}
.align-cnt
{
    text-align: center;
}
.events .v-slide-group__next, .events .v-slide-group__prev{
    min-width: 24px;
    -ms-flex: 0 1 52px;
    flex: 0 1 24px;
}
.events .v-slide-group__next .v-icon, .events .v-slide-group__prev .v-icon{
    color:#fff;
}
</style>